module.exports = __webpack_public_path__ + "img/newletter-28.6721c46.jpg";